// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iq","advertCardNum":"c-a_ir"};